import React, {Component} from 'react'
import {Form, Input as SInput, FormInputProps} from 'semantic-ui-react'
import {FastField, Field, getIn} from 'formik'
import ErrorMessage from './ErrorMessage'
import {InputRef} from './InputRef'
import {FormikComponentProps, getFieldError, setFieldValue} from './FormikHelpers'
import SemanticDatepicker from 'react-semantic-ui-datepickers'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import { SemanticDatepickerProps } from 'react-semantic-ui-datepickers/dist/types'
import csCZ from 'react-semantic-ui-datepickers/dist/locales/cs-CZ.json'
import { BlockList } from 'node:net'

// workaround for bug https://github.com/arthurdenner/react-semantic-ui-datepickers/issues/176
export class LocalizedDatepicker extends SemanticDatepicker {
    get locale () {
        return csCZ
    }
}

export interface DatePickerComponentProps extends FormikComponentProps {
    inputProps?: SemanticDatepickerProps
    inputRef?: (el: HTMLElement) => void
    noHighlighting?: boolean
}

class DatePicker extends Component<DatePickerComponentProps> {

  id: string

  constructor(props) {
    super(props)
    const {id, name} = props
    this.id = id || `field_input_${name}`
  }

  render() {
    const {
      name,
      label,
      validate,
      inputProps = {} as SemanticDatepickerProps,
      fieldProps = {},
      errorComponent = ErrorMessage,
      inputRef,
      fast,
      noHighlighting
    } = this.props
    const {onChange, ...safeInputProps} = inputProps
    const DesiredField = fast === true ? FastField : Field

    return (
      <DesiredField name={name} validate={validate}>
        {({field, form, meta}) => {
          const error = getFieldError(field, form)
          const value = field.value ? new Date(field.value) : null

          return (
            <Form.Field error={!!error} {...fieldProps}>
              {!!label && <label htmlFor={this.id}>{label}</label>}

              <InputRef inputRef={inputRef}>
                <LocalizedDatepicker
                  id={this.id}
                  name={name}
                  firstDayOfWeek={1}
                  format="D.M.YYYY"
                  clearable={true}
                  //{...safeInputProps}
                  value={value}
                  onChange={(e, {name, value}) => {
                    setFieldValue(form, name, value, true)
                    /*Promise.resolve().then(() => {
                      onChange && onChange(e, {name, value})
                    });*/
                  }}
                  onBlur={form.handleBlur}
                />
              </InputRef>

              {error && (
                React.createElement(errorComponent, { message: getIn(form.errors, name) })
              )}
            </Form.Field>
          );
        }}
      </DesiredField>
    );
  }
}

export default DatePicker